import { jsxs as C, jsx as r } from "react/jsx-runtime";
import { c as w } from "./clsx-OuTLNxxd.js";
import { C as q } from "./Check-CPyIclk1.js";
import * as d from "react";
import { useState as N, useId as O, useEffect as D } from "react";
import { u as G } from "./index-CCavb-1K.js";
import { c as M, P as z } from "./index-RcgQH_g_.js";
import { u as j, c as _ } from "./index-BAFn5Hvf.js";
import { u as A } from "./index-BZPx6jYI.js";
import { u as K } from "./index-D92Twj_n.js";
import { P as L } from "./index-Bl3O8yTo.js";
var H = "Checkbox", [V, ye] = M(H), [T, X] = V(H), B = d.forwardRef(
  (e, o) => {
    const {
      __scopeCheckbox: t,
      name: a,
      checked: h,
      defaultChecked: i,
      required: x,
      disabled: s,
      value: l = "on",
      onCheckedChange: u,
      ...v
    } = e, [n, p] = d.useState(null), I = G(o, (c) => p(c)), g = d.useRef(!1), S = n ? !!n.closest("form") : !0, [b = !1, k] = j({
      prop: h,
      defaultProp: i,
      onChange: u
    }), R = d.useRef(b);
    return d.useEffect(() => {
      const c = n == null ? void 0 : n.form;
      if (c) {
        const y = () => k(R.current);
        return c.addEventListener("reset", y), () => c.removeEventListener("reset", y);
      }
    }, [n, k]), /* @__PURE__ */ C(T, { scope: t, state: b, disabled: s, children: [
      /* @__PURE__ */ r(
        z.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": f(b) ? "mixed" : b,
          "aria-required": x,
          "data-state": E(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...v,
          ref: I,
          onKeyDown: _(e.onKeyDown, (c) => {
            c.key === "Enter" && c.preventDefault();
          }),
          onClick: _(e.onClick, (c) => {
            k((y) => f(y) ? !0 : !y), S && (g.current = c.isPropagationStopped(), g.current || c.stopPropagation());
          })
        }
      ),
      S && /* @__PURE__ */ r(
        F,
        {
          control: n,
          bubbles: !g.current,
          name: a,
          value: l,
          checked: b,
          required: x,
          disabled: s,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
B.displayName = H;
var W = "CheckboxIndicator", P = d.forwardRef(
  (e, o) => {
    const { __scopeCheckbox: t, forceMount: a, ...h } = e, i = X(W, t);
    return /* @__PURE__ */ r(L, { present: a || f(i.state) || i.state === !0, children: /* @__PURE__ */ r(
      z.span,
      {
        "data-state": E(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...h,
        ref: o,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
P.displayName = W;
var F = (e) => {
  const { control: o, checked: t, bubbles: a = !0, ...h } = e, i = d.useRef(null), x = A(t), s = K(o);
  return d.useEffect(() => {
    const l = i.current, u = window.HTMLInputElement.prototype, n = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (x !== t && n) {
      const p = new Event("click", { bubbles: a });
      l.indeterminate = f(t), n.call(l, f(t) ? !1 : t), l.dispatchEvent(p);
    }
  }, [x, t, a]), /* @__PURE__ */ r(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: f(t) ? !1 : t,
      ...h,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function f(e) {
  return e === "indeterminate";
}
function E(e) {
  return f(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var $ = B, J = P;
const Q = "320px", U = "600px", Y = "1025px", Z = "_isVisuallyHidden_nqlei_51", ee = "_checkbox_nqlei_63", te = "_shouldHighlightOnChecked_nqlei_73", oe = "_checked_nqlei_76", ie = "_checkboxBox_nqlei_87", ce = "_indicator_nqlei_98", ne = "_checkIcon_nqlei_108", se = "_checkboxGroup_nqlei_112", m = {
  mobile: Q,
  "mobile-wide": "480px",
  tablet: U,
  "tablet-wide": "800px",
  desktop: Y,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: Z,
  checkbox: ee,
  shouldHighlightOnChecked: te,
  checked: oe,
  checkboxBox: ie,
  indicator: ce,
  checkIcon: ne,
  checkboxGroup: se
}, pe = ({
  label: e,
  children: o,
  ...t
}) => (!e && !t["aria-label"] && !t["aria-labelledby"] && console.warn(
  "Checkbox group must provide and `aria-label` if no visible `label` prop is provided. If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"
), /* @__PURE__ */ C(
  "fieldset",
  {
    className: m.checkboxGroup,
    "aria-label": e ? void 0 : t["aria-label"],
    "aria-labelledby": e ? void 0 : t["aria-labelledby"],
    children: [
      e && /* @__PURE__ */ r("legend", { children: e }),
      o
    ]
  }
)), ge = ({
  checked: e,
  onCheckedChange: o,
  shouldHighlightOnChecked: t = !0,
  children: a,
  className: h,
  ...i
}) => {
  const [x, s] = N(e), l = O();
  return D(() => {
    s(e);
  }, [e]), /* @__PURE__ */ C(
    "label",
    {
      className: w(
        m.checkbox,
        {
          [m.checked]: x,
          [m.shouldHighlightOnChecked]: t
        },
        h
      ),
      id: l,
      children: [
        /* @__PURE__ */ r(
          $,
          {
            "aria-labelledby": l,
            ...i,
            className: m.checkboxBox,
            checked: x,
            onCheckedChange: (u) => {
              o == null || o(u), s(u);
            },
            children: /* @__PURE__ */ r(J, { className: m.indicator, children: /* @__PURE__ */ r(q, { size: "s", color: "blue" }) })
          }
        ),
        a
      ]
    }
  );
};
export {
  pe as C,
  ge as a
};
